import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';
import type { UserAdminStatsDTO } from '../dto/dtos';

export type ObtenirStatistiquesInput = void;
export type ObtenirStatistiquesOutput = UserAdminStatsDTO;

export class ObtenirStatistiquesUseCase implements IUseCase<ObtenirStatistiquesInput, ObtenirStatistiquesOutput> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(): Promise<ObtenirStatistiquesOutput> {
    const response = await this.repository.obtenirStatistiques();

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Erreur lors du chargement des statistiques');
    }

    // Utiliser 'any' pour gérer les différentes versions de l'API (noms fr/en)
    const stats = response.data.statistiques as any;

    // Mapper les noms du backend vers le DTO frontend
    return {
      total: stats.totalUtilisateurs ?? stats.total ?? 0,
      actifs: stats.utilisateursActifs ?? stats.actifs ?? 0,
      inactifs: stats.utilisateursInactifs ?? stats.inactifs ?? 0,
      verifies: stats.utilisateursVerifies ?? stats.verifies ?? 0,
      nonVerifies: stats.utilisateursNonVerifies ?? stats.nonVerifies ?? 0,
      parRole: stats.parRole ?? {},
      avec2FA: stats.utilisateurs2FAActifs ?? stats.avec2FA ?? 0,
      comptesBloques: stats.comptesVerrouilles ?? stats.comptesBloques ?? 0,
      connexionsRecentes: stats.connexionsRecentes ?? 0,
    } as UserAdminStatsDTO;
  }
}
